import styled from "@emotion/styled";
import {  Button, Col, Divider, Form, FormInstance, Modal, Row, message } from "antd";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import OrderDescriptionForm from "./OrderDescriptionForm";
import { useGetAgentByTelephone, useGetTransportationTypeByFactory } from "hooks/useFactory";
 import { useGetDatasource, useGetMasterProvince } from "hooks/useMasterData";
import MainCreateAgentAddress from "./MainCreateAgentAddress";
import { useRemoveAddressData } from "hooks/useAgents";
import { RemoveAddressDataInput } from "services/interface";
import { useQueryClient } from "@tanstack/react-query";
import { AddressData } from "components/ManageAgent/CreateAgent/AddressComponents/interface/address.interface";
import { useAppSelector } from "store";
   
interface MainCreateOrderAddressProps {
  // form: FormInstance;
  // telephoneData?: string;
  setTelephone: any;
  telephone: any;
  agentData: any;
  refetchData: any;
  handleSearchMobile: (tel:string) => void;
  setRadioSelect: Dispatch<SetStateAction<string>>;
  radioSelect: string;
  dataAddress:AddressData[];
  setDataAddress:Dispatch<SetStateAction<AddressData[]>>  
}

const MainCreateOrderAddress: FC<MainCreateOrderAddressProps> = ({
  // form,
  setTelephone,
  telephone,
  agentData,
  refetchData,
  handleSearchMobile,
  setRadioSelect,
  radioSelect,
  dataAddress,
  setDataAddress
}) => {

    const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
    const { data: transportationTypeData } = useGetTransportationTypeByFactory(factoryId ?? '');

  const { mutate: RemoveAddress, isPending: RemoveAddressIsLoading} = useRemoveAddressData();

  const { data: masterProviceData, isPending: proviceLoading } = useGetMasterProvince();
 
  const changeDefault = (id: string) => {
    setRadioSelect(id);
   }
 
  const handleRemoveItem = (target: string) => {
    const selectedDataAddress = dataAddress.find((item) => item.address_id === target);
    const dataInput: RemoveAddressDataInput = {
      ref_id: agentData?.data?.id || '',
      ref_type: agentData?.data?.ref_type || '',
      id: selectedDataAddress?.address_id || '' ,
    }
    RemoveAddress(dataInput, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("ลบที่อยู่ลูกค้าสำเร็จ");
          refetchData()
        } else {
          message.error(`ลบที่อยู่ลูกค้าไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`ลบที่อยู่ลูกค้าไม่สำเร็จ: ${error.message}`);
      },
    });

    // const updatedDataAddress = dataAddress.filter((item, index) => index !== target);
    // setDataAddress(updatedDataAddress);
  };
  const [formSearch] = Form.useForm();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);

  const showEdit = (id: string) => {
  }

  const onClose = () => {
    setOpen(false);
    // formSearch.resetFields(); 
  };

  
  useEffect(() => {
    if (agentData) {
      form.setFieldsValue({
        firstname: agentData?.data?.first_name || "",
        lastname: agentData?.data?.last_name || "",
        telephone: agentData?.data?.telephone_number || "",
        email: agentData?.data?.email || "",
      });
      // dataAddress
      const newAddresses:AddressData[] = agentData?.data?.address_ship?.map((address: any) => {
        return {
          address_id: address.address_id,
          transport_type: address.transport_type,
          line_1: address.address_line_1,
          line_2: address.address_line_2,
          location_type: address.location_type,
          address_text: address.address_text,
          province_id: address.province_id,
          province_name: address.province_name,
          district_id: address.district_id,
          district_name: address.district_name,
          sub_district_id: address.sub_district_id,
          sub_district_name: address.sub_district_name,
          post_code: address.zip_code,
          address_type: address.address_type,
          address_name: address.address_name,
          address_telephone: address.address_telephone,
          // address_detail: address?.address_detail,
          remark: address?.address_remark,
          // remark: address?.remark,
          parking_id: address?.parking_id,
          is_default: address?.is_default,
          last_address: address?.last_address,
        };
      });

    //filter address from transportationTypeData 
    const filteredAddress = newAddresses.filter((address) => {
      const found = transportationTypeData?.data?.find((transport) => transport.key === address.transport_type);
      return found;
    }
    );
  
      setDataAddress(filteredAddress);

      if (agentData?.data?.address_ship?.length === 1) {
        const singleAddressId = agentData.data.address_ship[0].address_id;
        setRadioSelect(singleAddressId);
      }
    }
  }, [agentData, form, transportationTypeData]);

  return (
  <>
    <>
      <Row>
          <Col span={24}>
              <OrderDescriptionForm handleSearchMobile={handleSearchMobile}  />
              {/* handleSearchMobile={handleSearchMobile}  */}
              {/* <FormWrapper>
                <FormItems
                  labelAlign="left"
                  label="ชื่อ"
                  name="mobile"
                  rules={[{ required: true, message: "กรุณากรอกเบอร์โทรศัพท์" }]}
                >
                  <Space.Compact>
                    <Input 
                      style={{height:'32px'}} 
                      placeholder="ค้นหาเบอร์โทรศัพท์" 
                      // onPressEnter={formSearch.submit}  
                    />
                  </Space.Compact>
                </FormItems>

                <Divider/>
            
              </FormWrapper> */}
              {/* <Button type="primary"  htmlType="submit">ค้นหา</Button>  */}

          </Col>
      </Row>
      <Divider />

      <MainCreateAgentAddress 
        dataAgent={agentData?.data}
        form={form}
        dataAddress={dataAddress}
        handleRemoveItem={handleRemoveItem}
        setDataAddress={setDataAddress}
        masterProviceData={masterProviceData}
        searchOption={false}
        refetch={refetchData}
        changeDefault={changeDefault}
        radioSelect={radioSelect}
       />
  </>
    <Modal
      title="ตรวจพบหมายเลข"
      open={open}
      maskClosable={false}
      onCancel={onClose}
      style={{ top: 20 }}
      // onOk={() => {
      //   formSearch.submit(); 
      // }}    
      cancelText="ยกเลิก" okText="ตกลง"
    >
      {/* <Form form={formSearch} onFinish={onFinish}>    */}
      {/* {...formItemLayout} onFinish={onEdit} */}
        {/* <UpdateAgentAddressForm 
          form={formEdit} 
          masterLocationData={masterLocationData}
          masterTransportData={masterTransportData}
          masterProviceData={masterProviceData} 
          masterDistrictData={masterDistrictData}
          masterSubDistrictData={masterSubDistrictData}
          selectedLocation={selectedLocationEdit} 
          setSelectedLocation={setSelectedLocationEdit}
          setProvinceId={setProvinceId}
          setDistrictId={setDistrictId}
        /> */}
      {/* </Form> */}
    </Modal>
  </>
  );
};

export default MainCreateOrderAddress;